import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconComponent } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-dialog-header',
	templateUrl: './dialog-header.component.html',
	styleUrls: ['./dialog-header.component.scss'],
	imports: [IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogHeaderComponent {
	title = input<string>();
	sluitbaar = input(false);

	sluiten = output<void>();
}
